module.exports = __webpack_public_path__ + "img/appAsset-brand--getnetclick.1ed6d833.svg";